import React, { useEffect, useState } from "react";
import { RateDataTables } from "components/DataTable/RateDataTables";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, DeleteCommanWay, ListCommanWay } from "API/commonApi";
import RateSearch from "./RateSearch";
import { AxiosResponse } from "axios";
import UseToast from "utils/AfToast";
import { useFormik } from "formik";
import RateAddEditSingleTable from "./RateAddEditSingleTable";
import { AfDataType } from "utils/TableColumnData";

interface RateListProps {
  tableName: string;
  columnData: any;
  children?: React.ReactNode;
}
const RateList: React.FC<RateListProps> = (props) => {
  const tableColumnData = [
    {
      label: "From",
      key: "from",
      type: AfDataType.NUMBER,
    },
    {
      label: "To",
      key: "to",
      type: AfDataType.NUMBER,
    },
    {
      label: "Rate",
      key: "rate",
      type: AfDataType.NUMBER,
    },
    {
      label: "Sunday",
      key: "sunday_rate",
      type: AfDataType.NUMBER,
    },
    {
      label: "TDD",
      key: "rate_1030_1230",
      type: AfDataType.NUMBER,
    },
    {
      label: "Wt Rng",
      key: "wt_range",
      type: AfDataType.NUMBER,
    },
    {
      label: "Add 10:30",
      key: "addition_1030",
      type: AfDataType.NUMBER,
    },
    {
      label: "Add Amt",
      key: "addition_amount",
      type: AfDataType.NUMBER,
    },
    {
      label: "AWB Chg",
      key: "ab_charge",
      type: AfDataType.NUMBER,
    },
    {
      label: "FS(%)",
      key: "f_charge",
      type: AfDataType.NUMBER,
    },
    {
      label: "CHC%",
      key: "chc_charge",
      type: AfDataType.NUMBER,
    },

    {
      label: "Dry Ice",
      key: "diceCharge",
      type: AfDataType.NUMBER,
    },
    {
      label: "dg",
      key: "dgCharge",
      type: AfDataType.NUMBER,
    },
    {
      label: "Pkg",
      key: "pkgCharge",
      type: AfDataType.NUMBER,
    },

    {
      label: "fov (%)",
      key: "fovCharge",
      type: AfDataType.NUMBER,
    },
    {
      label: "insurance (%)",
      key: "insuranceCharge",
      type: AfDataType.NUMBER,
    },
    {
      label: "ToPay Rate",
      key: "toPayCharge",
      type: AfDataType.NUMBER,
    },
    {
      label: "Datalogger Rate",
      key: "dataLoggerRate",
      type: AfDataType.NUMBER,
    },
  ];

  // Popup column data for package details
  const popupColumnData = [
    {
      label: "Pkg 1LT",
      key: "pkg1Charge",
      type: AfDataType.NUMBER,
    },
    {
      label: "Pkg 4LT",
      key: "pkg2Charge",
      type: AfDataType.NUMBER,
    },
    {
      label: "Pkg 10LT",
      key: "pkg3Charge",
      type: AfDataType.NUMBER,
    },
    {
      label: "Cube-6",
      key: "pkgMaster.cube6",
      type: AfDataType.NUMBER,
    },
    {
      label: "Cube-8",
      key: "pkgMaster.cube8",
      type: AfDataType.NUMBER,
    },
    {
      label: "Cube-13",
      key: "pkgMaster.cube13",
      type: AfDataType.NUMBER,
    },
  ];

  const [tableData, setTableData] = useState<any>([]);
  const [newTableData, setNewTableData] = useState<any>({});
  const [isVisible, setIsVisible] = useState<any>(false);
  const [isAnyChange, setIsAnyChange] = useState<boolean>(false);
  const [msg, setMsg] = useState<any>("");
  const [updateFormData, setUpdateFormData] = useState<any>({
    f_charge: null,
    chc_charge: null,
    ab_charge: null,
  });
  const [cellMode, setCellMode] = useState("N");
  const [formData, setFormData] = useState({});

  const [zoneADoxData, setZoneADoxdata] = useState([]);
  const [zoneBDoxData, setZoneBDoxdata] = useState([]);
  const [zoneANonDoxData, setZoneANonDoxData] = useState([]);
  const [zoneBNonDoxData, setZoneBNonDoxData] = useState([]);
  const [filterData, setFilterData] = useState<any>();

  const apiUrl = `/admin/${props.tableName}`;
  const routeUrl = `/master/${props.tableName}`;
  const columnData = props.columnData;
  const zonesArr = ["zone a", "zone b"];

  let incAry = [];
  columnData.forEach((c) => {
    if (c.db_col) {
      incAry.push("_" + c.db_col);
    }
  });

  const {
    mutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        const fetchData = data.data || [];
        setTableData(fetchData);

        let finaldata = {
          "zone a": {
            dox: [],
            nonDox: [],
          },
          "zone b": {
            dox: [],
            nonDox: [],
          },
        };
        console.log(fetchData);

        const sortedArray = fetchData.sort((a, b) => a.from - b.from);
        sortedArray.forEach((f) => {
          let _obj = {};
          // Include main table columns
          tableColumnData.forEach((td) => {
            _obj[td.key] = f[td.key];
          });
          // Include popup column data (pkg1Charge, pkg2Charge, pkg3Charge)
          popupColumnData.forEach((td) => {
            if (td.key.includes('.')) {
              // Handle nested keys like pkgMaster.cube6
              const [parent, child] = td.key.split('.');
              if (!_obj[parent]) _obj[parent] = {};
              // Parse pkgMaster if it's a JSON string
              let parentData = f[parent];
              if (typeof parentData === 'string') {
                try {
                  parentData = JSON.parse(parentData);
                } catch (e) {
                  parentData = {};
                }
              }
              _obj[parent][child] = parentData?.[child];
            } else {
              _obj[td.key] = f[td.key];
            }
          });
          finaldata[f.zone][f.is_dox ? "dox" : "nonDox"].push(_obj);
        });

        setZoneADoxdata(finaldata["zone a"].dox);
        setZoneBDoxdata(finaldata["zone b"].dox);
        setZoneANonDoxData(finaldata["zone a"].nonDox);
        setZoneBNonDoxData(finaldata["zone b"].nonDox);
        console.log(finaldata);

        return;
        if (!fetchData.length) {
          const arrayOfArrays = [
            ...zonesArr.map((zoneName) => {
              return [
                {
                  id: Math.round(Math.random() * Date.now()).toString(),
                  zone: zoneName,
                  is_dox: true,
                  ...formData,
                },
                {
                  id: Math.round(Math.random() * Date.now()).toString(),
                  zone: zoneName,
                  is_dox: false,
                  ...formData,
                },
              ];
            }),
          ];
          for (let i = 0; i < arrayOfArrays.length; i++) {
            const innerArray = arrayOfArrays[i];
            for (let j = 0; j < innerArray.length; j++) {
              const object = innerArray[j];
              fetchData.push(object);
            }
          }
        }

        setTableData(fetchData);
        setIsVisible(true);
        zonesArr.forEach((zoneName) => {
          setNewTableData((prevState) => {
            console.log(fetchData);
            let filteredData = fetchData.filter((element) => element.zone.toLowerCase() === zoneName);
            let newData = filteredData.length
              ? filteredData
              : [
                  { id: Math.round(Math.random() * Date.now()).toString(), zone: zoneName, is_dox: true, ...formData },
                  { id: Math.round(Math.random() * Date.now()).toString(), zone: zoneName, is_dox: false, ...formData },
                ];

            let hasDox = false;
            let hasNonDox = false;
            newData.forEach((a) => {
              if (a.is_dox == true) {
                hasDox = true;
              }
              if (a.is_dox == false) {
                hasNonDox = true;
              }
            });
            if (!hasDox) {
              newData.push({ id: Math.round(Math.random() * Date.now()).toString(), zone: zoneName, is_dox: true, ...formData });
            }
            if (!hasNonDox) {
              newData.push({ id: Math.round(Math.random() * Date.now()).toString(), zone: zoneName, is_dox: false, ...formData });
            }

            newData.sort((a, b) => a.from - b.from);
            prevState[zoneName] = newData;
            return prevState;
          });
        });
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: saveData,
    isLoading: isloadingData,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Data Added Successfully", "success");
        setIsVisible(false);
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const {
    mutate: deleteData,
    isLoading: isloadingDeletedData,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(DeleteCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Data deleted Successfully", "success");
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const handleChange = (e) => {
    setUpdateFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    setZoneADoxdata([]);
    setZoneBDoxdata([]);
    setZoneANonDoxData([]);
    setZoneBNonDoxData([]);
  }, [filterData]);

  const handleSaveButton = (e) => {
    let ids = tableData.map((t) => {
      return t.id;
    });
    console.log("id to delete", ids);
    let dataToAdd = [];
    zoneADoxData.forEach((data) => {
      data.from !== "" && data.to !== "" && dataToAdd.push({ ...data, zone: "zone a", is_dox: true });
    });
    zoneBDoxData.forEach((data) => {
      data.from !== "" && data.to !== "" && dataToAdd.push({ ...data, zone: "zone b", is_dox: true });
    });
    zoneANonDoxData.forEach((data) => {
      data.from !== "" && data.to !== "" && dataToAdd.push({ ...data, zone: "zone a", is_dox: false });
    });
    zoneBNonDoxData.forEach((data) => {
      data.from !== "" && data.to !== "" && dataToAdd.push({ ...data, zone: "zone b", is_dox: false });
    });
    tableColumnData.forEach((tdata) => {
      dataToAdd.forEach((da, index) => {
        if (tdata.type === AfDataType.NUMBER) {
          if (da[tdata.key]) {
            da[tdata.key] = Number(da[tdata.key]);
          }
          if(da[tdata.key] === ""){
            da[tdata.key] = null;
          }
        }
        dataToAdd[index] = { ...da, ...filterData };
      });
    });
    // Handle popup column data (convert numeric values)
    popupColumnData.forEach((tdata) => {
      dataToAdd.forEach((da, index) => {
        if (tdata.key.includes('.')) {
          // Handle nested keys like pkgMaster.cube6
          const [parent, child] = tdata.key.split('.');
          if (da[parent]?.[child] && tdata.type === AfDataType.NUMBER) {
            da[parent][child] = Number(da[parent][child]);
          }
          if (da[parent]?.[child] === "") {
            da[parent][child] = null;
          }
        } else {
          if (tdata.type === AfDataType.NUMBER) {
            if (da[tdata.key]) {
              da[tdata.key] = Number(da[tdata.key]);
            }
            if (da[tdata.key] === "") {
              da[tdata.key] = null;
            }
          }
        }
      });
    });
    console.log(dataToAdd);

    CreateCommanWay({ url: "/admin/rate/deleteMany", data: { isWarning: true, ids: ids } })
      .then((x) => {
        console.log("Delete done");
        CreateCommanWay({ url: "/admin/rate/addBulk", data: { data: dataToAdd } })
          .then((xx) => {
            UseToast("Rate Added Successfully", "success");
            setTimeout(() => {
              window.location.reload();
            }, 200);
          })
          .catch((err) => {
            UseToast("Failed to add data", "error");
            console.log("Delete failed", err);
          });
      })
      .catch((c) => {
        UseToast("Failed to delete data", "error");
        console.log("Delete failed", c);
      });
  };
  return (
    <>
      <RateSearch
        apiUrl={apiUrl}
        routeUrl={routeUrl}
        setIsVisible={setIsVisible}
        fetchRateList={mutate}
        setCellMode={setCellMode}
        cellMode={cellMode}
        formData={formData}
        setFormData={setFormData}
        saveData={handleSaveButton}
        newTableData={newTableData}
        setNewTableData={setNewTableData}
        setFilterData={setFilterData}
      />

      <RateAddEditSingleTable
        tableColumnData={tableColumnData}
        popupColumnData={popupColumnData}
        zone={"zone a"}
        isDox={true}
        tableData={zoneADoxData}
        setTableData={setZoneADoxdata}
      />
      <RateAddEditSingleTable
        tableColumnData={tableColumnData}
        popupColumnData={popupColumnData}
        zone={"zone a"}
        isDox={false}
        tableData={zoneANonDoxData}
        setTableData={setZoneANonDoxData}
      />
      <RateAddEditSingleTable
        tableColumnData={tableColumnData}
        popupColumnData={popupColumnData}
        zone={"zone b"}
        isDox={true}
        tableData={zoneBDoxData}
        setTableData={setZoneBDoxdata}
      />
      <RateAddEditSingleTable
        tableColumnData={tableColumnData}
        popupColumnData={popupColumnData}
        zone={"zone b"}
        isDox={false}
        tableData={zoneBNonDoxData}
        setTableData={setZoneBNonDoxData}
      />
    </>
  );
};

export default RateList;
